__turbopack_context__.v({
  "className": "poppins_37c74651-module__4izP_a__className",
  "variable": "poppins_37c74651-module__4izP_a__variable",
});
